//let crc32 = require('clover/utils/crc32')
//let linkMap = require('./linkmap')

export default class DownLoadTask {
  constructor(downFunc) {
    this.taskList = []
    this.maxCount = 1
    this.downFileList = []
    this.downFunc = downFunc
    this.init()
  }
  
  init(){
    for (let i = 0; i < this.maxCount; ++i){
      this.taskList.push({
        state:0
      })
    }
  
    //setInterval(()=>{this.checkDownload()}, 200)
  }
  
  checkDownload(){
    var self = this
    for (let i = 0; i < this.maxCount; ++i){
      if (self.taskList[i].state == 0){
        if (self.downFileList.length > 0){
          //let curItem = self.downFileList.pop()
          let curItem = self.downFileList.shift()
          self.taskList[i].state = 1
          self.downFunc(curItem.item, ()=>{
              self.taskList[i].state = 0
              if (curItem.cb){
                  curItem.cb(null, curItem.item)
              }
            self.checkDownload()
          })
        }
      }
    }
  }
  
  addDownFile(item, callback){
    this.downFileList.push({item:item, cb:callback})
    this.checkDownload()
  }
}
module.exports = DownLoadTask